/**
 * @module sagas/index.js
 *
 * This file is the application root saga from which all other sagas are spawned
 */
import { all } from 'redux-saga/effects';

import apiSaga from './Api';
import externalApiSaga from './ExternalApi';
import { taskManagerSpawnFactory } from './Helpers/SpawnedTaskManager';
import infiniteScroll from './InfiniteScroll';
import modalSaga from './Modal';
import musicSaga from './Music';
import overlaySaga from './Overlay';
import routingSaga from './Routing';
import shareSaga from './Share';
import smartConversionSaga from './SmartConversion';
import socialSaga from './Social';
import taskManager from './TaskManager';
import userSettingsSaga from './UserSettings';
import viewSaga from './View';

const spawn = taskManagerSpawnFactory();

/*
 * Get Root Application Saga
 */
function getSagas() {
  return [
    spawn(apiSaga),
    spawn(overlaySaga),
    spawn(externalApiSaga),
    spawn(musicSaga),
    spawn(modalSaga),
    spawn(smartConversionSaga),
    spawn(routingSaga),
    spawn(userSettingsSaga),
    spawn(viewSaga),
    spawn(taskManager),
    spawn(shareSaga),
    spawn(socialSaga),
    spawn(infiniteScroll),
  ];
}

export default function* rootSaga() {
  yield all(getSagas());
}
